import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-standing-instructions-popup',
  templateUrl: './standing-instructions-popup.component.html',
  styleUrls: ['./standing-instructions-popup.component.scss']
})
export class StandingInstructionsPopupComponent {

  isDirty: any;

  constructor(public dialogRef: MatDialogRef<StandingInstructionsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private sanitizer: DomSanitizer) { }


  onNoClick() {
    this.isDirty = false;
    this.dialogRef.close('true');
    this.canDeactivate()
  }
  canDeactivate(): boolean {
    return true
  }

  getSanitizedInstruction(instruction: string) {
    return this.sanitizer.bypassSecurityTrustHtml(instruction);
  }
}
